import { makeStyles } from 'tss-react/mui';

export const useExpandableSearchStyles = makeStyles<{ openWidth: number | string }>()(
  (theme, { openWidth }) => ({
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
    },
    triggerAbsoluteHidden: {
      position: 'absolute',
      right: 0,
      top: '50%',
      transform: 'translateY(-50%)',
      opacity: 0,
      pointerEvents: 'none',
    },
    inputWrapper: {
      display: 'flex',
      alignItems: 'center',
      overflow: 'hidden',
      transition: [
        theme.transitions.create('width', {
          easing: theme.transitions.easing.easeInOut,
          duration: theme.transitions.duration.standard,
        }),
        theme.transitions.create('opacity', {
          easing: theme.transitions.easing.easeIn,
          duration: theme.transitions.duration.shortest,
        }),
      ].join(', '),
    },
    inputWrapperOpen: {
      width: openWidth,
      opacity: 1,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    inputWrapperClosed: {
      width: 0,
      opacity: 0,
      pointerEvents: 'none',
    },
    actionIcon: {
      cursor: 'pointer',
    },
    input: {
      width: '100%',
      '& .MuiInputBase-root': {
        width: '100%',
        borderRadius: theme.shape.borderRadius,
        border: `1px solid ${theme.palette.primary.main}`,
        backgroundColor: 'transparent',
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
      },
      '& fieldset': {
        border: 'none',
      },
      '& input': {
        backgroundColor: 'transparent',
      },
      '& .MuiIconButton-root': {
        '&:hover': {
          backgroundColor: 'transparent',
        },
      },
    },
  }),
);
